import * as brandPage from './brandPage/reducer'
import * as brandsPage from './brandsPage/reducer'
import * as cancelSubscriptionPage from './cancelSubscriptionPage/reducer'
import * as careersPage from './careersPage/reducer'
import * as collectionPage from './collectionPage/reducer'
import * as collectionLandingPage from './collectionLandingPage/reducer'
import * as fragranceOfTheMonthPage from './fragranceOfTheMonthPage/reducer'
import * as invitePage from './invitePage/reducer'
import * as myOrdersPage from './myOrdersPage/reducer'
import * as orderInfoPage from './orderInfoPage/reducer'
import * as productDetailsModal from './productDetailsModal/reducer'
import * as postponedPremiumProduct from './postponedPremiumProduct/reducer'
import * as productPage from './productPage/reducer'
import * as quizPage from './quizPage/reducer'
import * as giftPage from './giftPage/reducer'
import * as incubatorPage from './incubatorPage/reducer'
import * as giftCardPage from './giftCardPage/reducer'
import * as quizRecommendationsPage from './quizRecommendationsPage/reducer'
import * as sentGiftsPage from './sentGiftsPage/reducer'
import * as smartSearchPage from './smartSearchPage/reducer'
import * as seoPage from './seoPage/reducer'
import * as paymentPage from './paymentPage/reducer'
import * as requestPage from './requestPage/reducer'
import * as pickPage from './pickPage/reducer'
import * as searchResultPage from './searchResultPage/reducer'
import * as zodiacSignPage from './zodiacSignPage/reducer'
import * as fragranceFinderPage from './fragranceFinderPage/reducer'
import * as profilePage from './profilePage/reducer'
import * as queueWidget from './queueWidget/reducer'
import * as trackingPage from './trackingPage/reducer'
import * as makeupLandingPage from './makeupLandingPage/reducer'
import * as skincareIntroPage from './skincareIntroPage/reducer'
import * as cosmeticsPage from './cosmeticsPage/reducer'
import * as navigation from './navigation/reducer'
import * as flashSaleBundlePage from './flashSaleBundlePage/reducer'
import * as fathersDayGiftSetPage from './fathersDayGiftSetPage/reducer'
import * as caseMonthlyDesignPage from './caseMonthlyDesignPage/reducer'
import * as shippingAndBillingIssuesModal from './shippingAndBillingIssuesModal/reducer'
import * as improveRecommendationsPage from './improveRecommendationsPage/reducer'


// new payment
import * as paymentPageNew from './paymentNew/reducer'
import * as redeemQueuePage from './paymentNew/redeemQueuePage/reducer'
import * as redeemTossInPage from './paymentNew/redeemTossInPage/reducer'
import * as subscribePrototypePage from './subscribePrototypePage/reducer'

// Leave in alphabet order!!!

export default {
  brandPage,
  brandsPage,
  cancelSubscriptionPage,
  careersPage,
  caseMonthlyDesignPage,
  collectionLandingPage,
  collectionPage,
  cosmeticsPage,
  fathersDayGiftSetPage,
  flashSaleBundlePage,
  fragranceFinderPage,
  fragranceOfTheMonthPage,
  giftCardPage,
  giftPage,
  improveRecommendationsPage,
  incubatorPage,
  invitePage,
  makeupLandingPage,
  myOrdersPage,
  navigation,
  orderInfoPage,
  paymentPage,
  pickPage,
  postponedPremiumProduct,
  productDetailsModal,
  productPage,
  profilePage,
  queueWidget,
  quizPage,
  quizRecommendationsPage,
  requestPage,
  searchResultPage,
  sentGiftsPage,
  seoPage,
  shippingAndBillingIssuesModal,
  skincareIntroPage,
  smartSearchPage,
  trackingPage,
  zodiacSignPage,

  // new payment
  paymentPageNew,
  redeemQueuePage,
  redeemTossInPage,
  subscribePrototypePage,
}
